class TestData {
    constructor() {
        var _a;
        this.data = (_a = localStorage.getItem(TestData.localStorageId)) !== null && _a !== void 0 ? _a : '';
    }
    toString() {
        return this.data;
    }
}
TestData.localStorageId = 'testData';
export default TestData;
